import axios from "axios"

export const config = {
    // Ztpl
    // appUrl: "/precisioncontractdriving/",
    // imageUrl: "https://ztpl.net/precisioncontractdriving/backend/public/images/",
    // ClientUrl: "https://ztpl.net/precisioncontractdriving/instructor/sign-up",
    // StudentUrl: "https://ztpl.net/precisioncontractdriving/student",

    // Live
    // appUrl: "/",
    // imageUrl: "https://api.precisiondriving.uk/public/images/",
    // ClientUrl: "https://precisiondriving.uk/instructor/sign-up",
    // StudentUrl: "https://precisiondriving.uk/student"

    // Demo
    appUrl: "/",
    imageUrl: "https://apidemo.precisiondriving.uk/public/images/",
    ClientUrl: "https://demo.precisiondriving.uk/instructor/sign-up",
    StudentUrl: "https://demo.precisiondriving.uk/student"
}

export const axiosInstance = axios.create({
    // baseURL: 'https://ztpl.net/precisioncontractdriving/backend/public/api/'
    // baseURL: 'https://api.precisiondriving.uk/public/api/'
    baseURL: 'https://apidemo.precisiondriving.uk/public/api/'
})